import React, { Component } from "react";
import Header from "../header";
import Select from "react-select";
import SimpleReactValidator from "simple-react-validator";
import BounceLoader from "react-spinners/BounceLoader";
import axios from "axios";
import toast from "react-hot-toast";
import { apiCall_domain, apiCall_domainV2 } from "../api";
import { PulseLoader } from "react-spinners";

const Headers = {
  Authorization: localStorage.getItem("Api_key"),
  "content-type": "application/json",
};

class LegalInfo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      provinces: [],
      orgName: "",
      nationalId: "",
      registerId: "",
      taxNumber: "", // New field
      legalState: null,
      legalCity: null,
      legalPhone: "",
      postalCode: "",
      address: "",
      haveLegal: false,
      loading: false,
      section: "legal",
    };

    this.validator = new SimpleReactValidator({
      element: (msg) => <p className={"error"}>{msg}</p>,
      messages: {
        required: "این فیلد الزامی است",
        numeric: "فقط عدد وارد کنید",
        size: "تعداد ارقام صحیح نیست",
        min: "حداقل طول رعایت نشده",
      },
      autoForceUpdate: this,
    });
  }

  componentDidMount() {
    const splash = localStorage.getItem("splash");
    const parsedSplash = JSON.parse(splash);
    this.setState({ provinces: parsedSplash.cities });

    const legalProvince =
      parsedSplash.legal_info &&
      parsedSplash.cities.find(
        (s) => s.id === parsedSplash.legal_info.city.province_id,
      );

    if (parsedSplash.legal_info) {
      this.setState({
        orgName: parsedSplash.legal_info?.organization_name,
        nationalId: parsedSplash.legal_info?.legal_national_id,
        registerId: parsedSplash.legal_info?.registration_id,
        taxNumber: parsedSplash.legal_info?.tax_number || "", // Set existing tax number if available
        legalPhone: parsedSplash.legal_info?.phone,
        postalCode: parsedSplash.legal_info?.postal_code,
        address: parsedSplash.legal_info?.address,
        legalState: {
          value: legalProvince.id,
          label: legalProvince.name,
          cities: legalProvince.cities,
        },
        legalCity: {
          value: parsedSplash.legal_info?.city.id,
          label: parsedSplash.legal_info?.city.name,
        },
        haveLegal: parsedSplash.legal_info ? true : false,
      });
    }
  }

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  changeLegalState = (legalState) => {
    this.setState({ legalState, legalCity: null });
  };

  changeLegalCity = (legalCity) => {
    this.setState({ legalCity });
  };

  updateLegalProfile = (data) => {
    return axios.post(`${apiCall_domainV2}/customer/legal/create`, data, {
      headers: Headers,
    });
  };

  update = (e) => {
    e.preventDefault();

    if (this.validator.allValid()) {
      this.setState({ loading: true });
      const data = {
        organization_name: this.state.orgName,
        legal_national_id: this.state.nationalId,
        registration_id: this.state.registerId,
        tax_number: this.state.taxNumber, // Include tax number in API payload
        city_id: this.state.legalCity.value,
        phone: +this.state.legalPhone,
        postal_code: this.state.postalCode,
        address: this.state.address,
      };

      this.updateLegalProfile(data)
        .then(() => this.afterSuccess())
        .catch(() => this.afterError());
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };

  afterSuccess = () => {
    toast.success("اطلاعات با موفقیت ثبت شد");
    axios
      .get(`${apiCall_domain}/customer/splash`, { headers: Headers })
      .then((res) => {
        this.setState({ loading: false });
        localStorage.setItem("splash", JSON.stringify(res.data));
        window.history.goBack();
      });
  };

  afterError = () => {
    toast.error("خطا در ثبت اطلاعات");
    this.setState({ loading: false });
  };

  render() {
    const {
      orgName,
      nationalId,
      registerId,
      taxNumber, // New field
      legalState,
      legalCity,
      legalPhone,
      postalCode,
      address,
      haveLegal,
      loading,
      section,
      provinces,
    } = this.state;

    return (
      <>
        <Header
          showSearchBar={true}
          title="اطلاعات حقوقی"
          changeDetail={true}
        />

        <div className="legalContent">
          <form>
            <div className="formGroup">
              <label className="required">نام سازمان</label>
              <input
                className="input"
                name="orgName"
                value={orgName}
                onChange={this.handleInputChange}
                placeholder="نام کامل شرکت یا سازمان"
              />
              {this.validator.message("orgName", orgName, "required")}
            </div>

            <div className="formGroup">
              <label className="required">شناسه ملی</label>
              <input
                className="input"
                name="nationalId"
                value={nationalId}
                onChange={this.handleInputChange}
                placeholder="شناسه ملی ۱۱ رقمی"
              />
              {this.validator.message(
                "nationalId",
                nationalId,
                "required|numeric|size:11",
              )}
            </div>

            <div className="formGroup">
              <label className="required">شناسه ثبت</label>
              <input
                className="input"
                name="registerId"
                value={registerId}
                onChange={this.handleInputChange}
                placeholder="شماره ثبت شرکت"
              />
              {this.validator.message(
                "registerId",
                registerId,
                "required|numeric",
              )}
            </div>

            <div className="formGroup">
              <label className="required">شماره مالیاتی</label>
              <input
                className="input"
                name="taxNumber"
                value={taxNumber}
                onChange={this.handleInputChange}
                placeholder="شماره مالیاتی شرکت"
              />
              {this.validator.message(
                "taxNumber",
                taxNumber,
                "required|numeric",
              )}
            </div>

            <div className="formGroup">
              <label className="required">استان دفتر مرکزی</label>
              <Select
                placeholder="انتخاب استان"
                value={legalState}
                onChange={this.changeLegalState}
                options={provinces.map((s) => ({
                  value: s.id,
                  label: s.name,
                  cities: s.cities,
                }))}
              />
              {this.validator.message("legalState", legalState, "required")}
            </div>

            <div className="formGroup">
              <label className="required">شهر دفتر مرکزی</label>
              <Select
                placeholder="انتخاب شهر"
                value={legalCity}
                onChange={this.changeLegalCity}
                options={
                  legalState?.cities?.map((c) => ({
                    value: c.id,
                    label: c.name,
                  })) || []
                }
              />
              {this.validator.message("legalCity", legalCity, "required")}
            </div>

            <div className="formGroup">
              <label className="required">تلفن ثابت</label>
              <input
                className="input"
                name="legalPhone"
                value={legalPhone}
                onChange={this.handleInputChange}
                placeholder="مثال: 04133334444"
              />
              {this.validator.message(
                "legalPhone",
                legalPhone,
                "required|numeric|min:8",
              )}
            </div>

            <div className="formGroup">
              <label className="required">کد پستی</label>
              <input
                className="input"
                name="postalCode"
                value={postalCode}
                onChange={this.handleInputChange}
                placeholder="کد پستی ۱۰ رقمی"
              />
              {this.validator.message(
                "postalCode",
                postalCode,
                "required|numeric|size:10",
              )}
            </div>

            <div className="formGroup">
              <label className="required">آدرس دفتر مرکزی</label>
              <textarea
                name="address"
                value={address}
                onChange={this.handleInputChange}
                rows={3}
              />
              {this.validator.message("address", address, "required|min:5")}
            </div>

            <div className="formGroup submitGroup">
              <button onClick={this.update}>
                {loading ? <PulseLoader color="#fff" /> : "ثبت اطلاعات"}
              </button>
            </div>
          </form>
        </div>
      </>
    );
  }
}

export default LegalInfo;
